import type { ReactNode } from "react";

export function EmptyState({
  title,
  action,
}: {
  title: string;
  action?: ReactNode;
}) {
  return (
    <div className="empty">
      <svg className="empty__mark" viewBox="0 0 160 160" aria-hidden>
        {Array.from({ length: 8 }).map((_, i) => {
          const a = (i * Math.PI) / 4;
          const x = 80 + Math.cos(a) * 60;
          const y = 80 + Math.sin(a) * 60;
          return <line key={i} x1="80" y1="80" x2={x} y2={y} stroke="currentColor" strokeWidth="1" />;
        })}
        <circle cx="80" cy="80" r="60" stroke="currentColor" strokeWidth="1" fill="none" />
        <circle cx="80" cy="80" r="40" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.6" />
        <circle cx="80" cy="80" r="20" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.3" />
        <circle cx="80" cy="80" r="3" fill="currentColor" />
      </svg>
      <div className="empty__title">{title}</div>
      {action ? <div className="empty__action">{action}</div> : null}
    </div>
  );
}
